
/* eslint no-unused-vars: 0 */
import ifDefined from '@ui5/webcomponents-base/dist/renderer/ifDefined.js';
import { html, svg, repeat, classMap, styleMap, unsafeHTML, setTags, setSuffix } from '@ui5/webcomponents-base/dist/renderer/LitRenderer.js';
const block0 = (context) => { return html`<div class="${classMap(context.classes.root)}"><div class="ui5-busyindicator-wrapper">${ context.active ? block1(context) : undefined }${ context.text ? block2(context) : undefined }</div><slot></slot></div>`; };
const block1 = (context) => { return html`<div class="ui5-busyindicator-dynamic-content" role="progressbar" aria-valuemin="0" aria-valuemax="100" title="${ifDefined(context.ariaTitle)}"><div class="ui5-busyindicator-circle circle-animation-0"></div><div class="ui5-busyindicator-circle circle-animation-1"></div><div class="ui5-busyindicator-circle circle-animation-2"></div></div>`; };
const block2 = (context) => { return html`<ui5-label class="ui5-busyindicator-text">${ifDefined(context.text)}</ui5-label>`; };


const main = (context, tags, suffix) => {
	setTags(tags);
	setSuffix(suffix);
	return block0(context);
};
 
export default main;